import React from "react";

import { api } from "api";

import { useFetchList } from "../use-fetch";

type Item = { name: string; breaktime: number; linkedWith: string[] };

type ListTagItem = { name: string; items: Item[] };

export const useSideBarTags = () => {
  const { data: publics, loading: publicsLoading } = useFetchList({
    request: api.tags.public.list,
  });
  const { data: privates, loading: privatesLoading } = useFetchList({
    request: api.tags.private.list,
  });

  const loading = React.useMemo(() => {
    return privatesLoading || publicsLoading;
  }, [privatesLoading, publicsLoading]);

  const data = React.useMemo(() => {
    const list: ListTagItem[] = [];

    publics
      .map((item) => ({
        name: item.name,
        items: item.tags.map(
          (i) =>
            ({
              name: i.name,
              breaktime: i.breakTime,
              linkedWith: i.linkedWith,
            } as Item)
        ),
      }))
      .forEach((item) => list.push(item));

    const privateNames = privates
      .map(
        (item) => ({ name: item.name, linkedWith: [], breaktime: 0 } as Item)
      )
      .flat(1);
    list.push({ name: "Private", items: privateNames });

    return list;
  }, [privates, publics]);

  return { loading, data } as const;
};
